import { QueryClient } from '@tanstack/react-query';
import { AxiosError } from "axios";
import config from "react-global-configuration";
import { getNotificationStyle } from "../common/notification";
import { IManifestChargeFilter } from "../components/FilterComponent/ManifestChargeFilterComponent";
import { IFetchFiles } from "../model/BookingModel";
import { POD_DISPATCH_CLIENT_ID, toStringArray } from "../utils/app-common";
import {
    Category,
    DownloadSOAFileRequest,
    GeofenceSaveRequest,
    GeofenceUpdateRequest,
    IAssignUnAssignType,
    ICancelRequest,
    IComplaintAssignment,
    IComplaintCommentsList,
    ICustomerComplaintFilter,
    ICustomerComplaintList,
    IFTLTripPlanFilterParams,
    IFilter,
    IFuelFilterParams,
    IFuelAuditPaginatedFilterParams,
    IFuelTrackingRequest,
    IGetFiles,
    IManifestFileUploads,
    IMarkenResponse,
    INotify,
    IOdometerFilterParams,
    IOdometerRequest,
    IPODPendingSearchFilter,
    IPieceTrackingSearchFilter,
    IPieceType,
    IPodFilterParams,
    IPodWaybillsRequestList,
    IPrintBarCodes,
    IPrintPieceBarCodes,
    IPrintPieceBarcodes,
    ISalesPersonManifestRejectRequest,
    ISalesPersonManifestRespond,
    IShipmentSummaryDetailsRequest,
    IShipmentSummaryRequest,
    IShipperConsigneeCoordsUpdate,
    IVehicleVisibility,
    IVehicleVisibilityFilter,
    IdleVehicleApproveRejectExceptionRequest,
    IdleVehicleCancelExceptionRequest,
    IdleVehicleExceptionRequest,
    IdleVehicleFilterParams,
    InvoiceStagingFilterParams,
    InvoiceStagingParams,
    MetabaseRequestData,
    PaginationParams,
} from "./../model/CommonModel";
import { IPrintPallet } from "./../model/PalletModel";
import AjexPortalService from "./api";

const countryId = config.get("countryId");
const city = config.get("city");
const cityId = config.get("cityId");
const odaCity = config.get("odaCity");
const industryType = config.get("industryType");
const employee = config.get("employee");
const salesPerson = config.get("salesPerson");
const currency = config.get("currency");
const waybillSticker = config.get("waybillSticker");
const manualWayBill = config.get("manualWayBill");
const print = config.get("print");
const palletSticker = config.get("palletSticker");
const booking = config.get("booking");
const filter = config.get("filter");
const division = config.get("division");
const business = config.get("business");
const exceptionCategory = config.get("exceptionCategory");
const cityGroup = config.get("cityGroup");
const position = config.get("position");
const station = config.get("station");
const region = config.get("region");
const fileAttachment = config.get("fileAttachment");
const downloadFile = config.get("downloadFile");
const manifest = config.get("manifest");
const getFiles = config.get("getFiles");
const upload = config.get("upload");
const category = config.get("category");
const exceptionReason = config.get("exceptionReason");
const barcode = config.get("barcode");
const tripplanDriverStatus = config.get("tripplanDriverStatus");
const pickupPieceSticker = config.get("pickupPieceSticker");
const report = config.get("report");
const download = config.get("download");
const cashDetail = config.get("cashDetail");
const pendingCash = config.get("pendingCash");
const podInProgress = config.get("podInProgress");
const podDispatch = config.get("podDispatch");
const podPending = config.get("podPending");
const printDeliverySheet = config.get("printDeliverySheet");
const podClosed = config.get("podClosed");
const podClientSubId = config.get("podClientSubId");
const shipper = config.get("shipper");
const consignee = config.get("consignee");
const podDispatchPrint = config.get("podDispatchPrint");
const podConfirm = config.get("podConfirm");
const getPodWaybills = config.get("getPodWaybills");
const pieceBarcodeTracking = config.get("pieceBarcodeTracking");
const activity = config.get("activity");
const packaging = config.get("packaging");
const marken = config.get("marken");
const truckType = config.get("truckType");
const irsWaybill = config.get("irsWaybill");
const packagingTemp = config.get("packagingTemp");
const byPackaging = config.get("byPackaging");
const packagingSize = config.get("packagingSize");
const byPackagingTemp = config.get("byPackagingTemp");
const airportCode = config.get("airportCode");
const shipmentTemperature = config.get("shipmentTemperature");
const downloadByCategory = config.get("downloadByCategory");
const downloadByCategoryId = config.get("downloadByCategoryId");
const categoryId = config.get("categoryId");
const sales = config.get("sales");
const confirm = config.get("confirm");
const reject = config.get("reject");
const customerComplaint = config.get("customerComplaint");
const complaintCategory = config.get("complaintCategory");
const complaintPriority = config.get("complaintPriority");
const customerComplaintComment = config.get("customerComplaintComment");
const byComplaint = config.get("byComplaint");
const complaintStatus = config.get("complaintStatus");
const pickupPieceStickerBulk = config.get("pickupPieceStickerBulk");
const manifestSalesman = config.get("manifestSalesman");
const vehicleVisibility = config.get("vehicleVisibility");
const vehicle = config.get("vehicle");
const vehicleStatusHistory = config.get("vehicleStatusHistory");
const cashWaybill = config.get("cashWaybill");
const industryGroup = config.get("industryGroup");
const fleet = config.get("fleet");
const assignment = config.get("assignment");
const cancel = config.get("cancel");
const notifyDriver = config.get("notifyDriver");
const adhocFleetAssignment = config.get("adhocFleetAssignment");
const calendar = config.get("calendar");
const page = config.get("page");
const size = config.get("size");
const vehicleFuelTracking = config.get("vehicleFuelTracking");
const odometerTracking = config.get("odometerTracking");
const tripPlan = config.get("tripPlan");
const wayBill = config.get("wayBill");
const commonUrl = process.env.REACT_APP_TMS_COMMON_SERVICE;
const reportURL = process.env.REACT_APP_TMS_REPORT_SERVICE;
const readURL = process.env.REACT_APP_TMS_READ_SERVICE;
const complaintURL = process.env.REACT_APP_TMS_COMPLAINT_MANAGEMENT_SERVICE;
const CRMURL = process.env.REACT_APP_TMS_CRM_SERVICE;
const fleetURL = process.env.REACT_APP_TMS_FLEET_MANAGEMENT_SERVICE;
const geofencingURL = process.env.REACT_APP_TMS_GEOFENCING_SERVICE;
const occURL = process.env.REACT_APP_TMS_OCC_SERVICE;
const bookingURL = process.env.REACT_APP_API_BOOING_SERVICE_BASE_URL;
const invoiceStagingUrl = process.env.REACT_APP_INVOICE_STAGING_URL;

export const GetOriginListService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${city}/${countryId}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetFtlOriginListService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${city}/ftl-country-id/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetPackageTempListService = async (id: number) => {
    try {
        return await AjexPortalService.get(
            `${reportURL}/${packagingTemp}/${byPackaging}/${id}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetPackageSizeListService = async (id: number) => {
    try {
        return await AjexPortalService.get(
            `${reportURL}/${packagingSize}/${byPackagingTemp}/${id}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetSubCityListService = async (id?: number) => {
    try {
        return await AjexPortalService.get(`${odaCity}/${cityId}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetIndustryListService = async () => {
    try {
        return await AjexPortalService.get(`${industryType}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};
export const GetIndustriesGroupListService = async () => {
    try {
        return await AjexPortalService.get(`${reportURL}/${industryGroup}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const GetActivityListService = async () => {
    try {
        return await AjexPortalService.get(`${reportURL}/${activity}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const GetPackagingListService = async () => {
    try {
        return await AjexPortalService.get(`${reportURL}/${packaging}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const GetAirportCodeListService = async () => {
    try {
        return await AjexPortalService.get(`${reportURL}/${airportCode}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetShipmentTemperatureListService = async () => {
    try {
        return await AjexPortalService.get(`${reportURL}/${shipmentTemperature}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetTruckTypeListService = async () => {
    try {
        return await AjexPortalService.get(`${reportURL}/${truckType}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const GetMarkenByIdService = async (id: number | undefined) => {
    try {
        return await AjexPortalService.get(
            `${commonUrl}/${marken}/${booking}/${id}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SaveMarkenService = async (data?: Partial<IMarkenResponse>) => {
    try {
        return await AjexPortalService.post(`${commonUrl}/${marken}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const UpdateMarkenService = async (
    id: number | undefined,
    data: IMarkenResponse
) => {
    try {
        return await AjexPortalService.put(
            `${commonUrl}/${marken}/${booking}/${id}`,
            data
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const GetSalesPersonService = async () => {
    try {
        //employee/sales-person
        return await AjexPortalService.get(`${employee}/${salesPerson}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetCurrencyService = async () => {
    try {
        return await AjexPortalService.get(`${currency}/`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};
export const PrintWayBillService = async (airWayBill: string) => {
    try {
        return await AjexPortalService.get(
            `${commonUrl}${print}/${manualWayBill}/${airWayBill}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const PrintStickerService = async (airWayBill: string) => {
    try {
        //print/waybill-sticker/A10000010000016
        return await AjexPortalService.get(
            `${commonUrl}${print}/${waybillSticker}/${airWayBill}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const PrintPalletService = async (data: IPrintPallet[]) => {
    try {
        //pallet-sticker
        //print/waybill-sticker/A10000010000016
        return await AjexPortalService.post(
            `${commonUrl}${print}/${palletSticker}`,
            data
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SearchFilterService = async (filteredData: IFilter) => {
    try {
        ///api/v1/booking/filter
        return await AjexPortalService.post(`${booking}/${filter}`, filteredData);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetDivisionService = async () => {
    try {
        return await AjexPortalService.get(`${division}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};
export const GetBusinessService = async () => {
    try {
        return await AjexPortalService.get(`${business}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};
export const GetPositionService = async () => {
    try {
        return await AjexPortalService.get(`${position}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetStationService = async () => {
    try {
        return await AjexPortalService.get(`${station}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetEmployeeDropDownService = async () => {
    try {
        return await AjexPortalService.get(`${employee}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetExceptionCategoryService = async () => {
    try {
        return await AjexPortalService.get(`${exceptionCategory}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetCityGroupService = async () => {
    try {
        return await AjexPortalService.get(`${cityGroup}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetRegionByCountryListService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${region}/${countryId}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const DownloadFilesActionService = async (id: number) => {
    //file-attachment/download-file/105
    try {
        return await AjexPortalService.get(
            `${commonUrl}${fileAttachment}/${downloadFile}/${id}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetUploadedFileListService = async (request: IGetFiles) => {
    try {
        return await AjexPortalService.get(
            `${commonUrl}${fileAttachment}/${downloadByCategoryId}?${categoryId}=${request?.categoryId}&${category}=${request?.category}&fileType=${request?.fileType}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const DownloadManifestFilesService = async (id: number) => {
    try {
        return await AjexPortalService.get(
            `${commonUrl}${manifest}/${downloadFile}/${id}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const DownloadMarkenFilesService = async (id: number) => {
    try {
        return await AjexPortalService.get(
            `${commonUrl}${fileAttachment}/${downloadFile}/${id}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetManifestFilesListService = async (wayBillNumber?: string) => {
    try {
        return await AjexPortalService.get(
            `${commonUrl}${manifest}/${getFiles}/${wayBillNumber}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetMarkenFilesListService = async (wayBillNumber: string) => {
    try {
        return await AjexPortalService.get(
            `${commonUrl}${fileAttachment}/${downloadByCategory}?waybillNo=${wayBillNumber}&category=booking&fileType=Marken`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetManifestSalesmanService = async (
    data: IManifestChargeFilter
) => {
    try {
        return await AjexPortalService.post(
            `${reportURL}${report}/${manifestSalesman}`,
            data
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const UploadManifestFileService = async (
    fileObject: IManifestFileUploads
) => {
    try {
        return await AjexPortalService.post(
            `${commonUrl}${manifest}/${upload}`,
            fileObject
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetExceptionListByCategoryIdService = async (
    id: number | undefined
) => {
    try {
        return await AjexPortalService.get(`${exceptionReason}/${category}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

//https://apps-sit.aj-ex.com/tms-common-service/api/v1/print/barcode
export const PrintBarCodeService = async (request: IPrintBarCodes[]) => {
    try {
        return await AjexPortalService.post(
            `${commonUrl}${print}/${barcode}`,
            request
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetTripplanDriverStatusListService = async () => {
    try {
        return await AjexPortalService.get(`${commonUrl}${tripplanDriverStatus}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetAllPieceLevelService = async () => {
    try {
        return await AjexPortalService.get(`${commonUrl}re-weight/piece-types-all`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetPieceLevelService = async (request: IPieceType) => {
    try {
        return await AjexPortalService.post(
            `${commonUrl}re-weight/piece-types`,
            request
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetPodInProgressService = async () => {
    try {
        return await AjexPortalService.get(
            `${commonUrl}${podDispatch}/${podInProgress}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetPodInProgressPaginatedService = async (paginationParams: PaginationParams, filterParams?: IPodFilterParams, isAone?: boolean) => {
    const { current, pageSize } = paginationParams || {};
    const { waybill } = filterParams || {};
    const aoneParam = isAone ? '&isAone=true' : '';
    const waybillParam = waybill ? `&waybill=${waybill}` : '';
    try {
        return await AjexPortalService.get(
            `${commonUrl}${podDispatch}/${podInProgress}/paginated?page=${current}&size=${pageSize}${waybillParam}${aoneParam}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetPodDispatchWaybillsService = async () => {
    try {
        return await AjexPortalService.get(`${reportURL}${podDispatch}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetPodPendingService = async () => {
    try {
        return await AjexPortalService.get(
            `${commonUrl}${podDispatch}/${podPending}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SearchPodPendingFilterService = async (
    filteredData: IPODPendingSearchFilter
) => {
    try {
        ///api/v1/booking/filter
        return await AjexPortalService.post(
            `${commonUrl}${podDispatch}/${filter}/${podPending}`,
            filteredData
        );
        // return await AjexPortalService.post(`http://localhost:6200/api/v1/booking/filter`, filteredData);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetPodShippersService = async () => {
    try {
        return await AjexPortalService.get(
            `${shipper}/${podClientSubId}/${POD_DISPATCH_CLIENT_ID}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetPodConsigneesService = async () => {
    try {
        return await AjexPortalService.get(
            `${consignee}/${podClientSubId}/${POD_DISPATCH_CLIENT_ID}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const PrintPieceBarcodeService = async (data: IPrintPieceBarcodes) => {
    try {
        return await AjexPortalService.post(
            `${commonUrl}${print}/${pickupPieceSticker}`,
            data
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
//https://apps-sit.aj-ex.com/tms-common-service/api/v1/print/new-pickup-piece-sticker-bulk
export const PrintPieceBarCodeService = async (data: IPrintPieceBarCodes) => {
    try {
        return await AjexPortalService.post(
            `${commonUrl}${print}/${pickupPieceStickerBulk}`,
            data
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const ExportPendingCashService = async (data: IFilter) => {
    try {
        return await AjexPortalService.post(
            `${reportURL}${report}/${download}/${cashDetail}/${pendingCash}`,
            data
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
};
export const GetPodCloseService = async () => {
    try {
        return await AjexPortalService.get(
            `${commonUrl}${podDispatch}/${podClosed}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetPodClosedPaginatedService = async (paginationParams: PaginationParams, filterParams?: IPodFilterParams, isAone?: boolean) => {
    const { current, pageSize } = paginationParams || {};
    const { waybill } = filterParams || {};
    const aoneParam = isAone ? '&isAone=true' : '';
    try {
        return await AjexPortalService.get(
            `${commonUrl}${podDispatch}/${podClosed}/paginated?page=${current}&size=${pageSize}&waybill=${waybill ?? ""}${aoneParam}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const PrintDeliverySheetService = async (id: number) => {
    try {
        //https://apps-sit.aj-ex.com/tms-common-service/api/v1/print/delivery-sheet-print/73
        return await AjexPortalService.get(
            `${commonUrl}${print}/${printDeliverySheet}/${id}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
};
export const PrintPodDispatchService = async (waybill: string | undefined) => {
    try {
        return await AjexPortalService.get(
            `${reportURL}${report}/${podDispatchPrint}/${waybill}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
};
export const GetPodWaybillsService = async (wayBillNumber: string) => {
    try {
        return await AjexPortalService.get(
            `${commonUrl}${podDispatch}/${getPodWaybills}/${wayBillNumber}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SavePodWaybillsService = async (data: IPodWaybillsRequestList) => {
    try {
        ///api/v1/booking/filter
        return await AjexPortalService.post(
            `${commonUrl}${podDispatch}/${podConfirm}`,
            data
        );
        // return await AjexPortalService.post(`http://localhost:6200/api/v1/booking/filter`, filteredData);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const SearchPieceBarcodeTrackingFilterService = async (
    filteredData: IPieceTrackingSearchFilter
) => {
    try {
        return await AjexPortalService.post(
            `${reportURL}${pieceBarcodeTracking}/${filter}`,
            filteredData
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const PrintCashRecieptService = async (airWayBill: string) => {
    try {
        return await AjexPortalService.get(
            `${readURL}${print}/${cashWaybill}/${airWayBill}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const PrintIRSReportService = async (airWayBill: string) => {
    try {
        return await AjexPortalService.get(
            `${readURL}${print}/${irsWaybill}/${airWayBill}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const ConfirmManifestByIdService = async (
    data: ISalesPersonManifestRespond,
    id: number
) => {
    try {
        return await AjexPortalService.post(
            `${commonUrl}${manifest}/${sales}/${confirm}/${id}`,
            data
        );
        // return await AjexPortalService.post(`http://localhost:6200/api/v1/booking/filter`, filteredData);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const RejectManifestByIdService = async (
    data: ISalesPersonManifestRejectRequest,
    id: number
) => {
    try {
        return await AjexPortalService.post(
            `${commonUrl}${manifest}/${sales}/${reject}/${id}`,
            data
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetCustomerComplaintListService = async () => {
    try {
        return await AjexPortalService.get(`${complaintURL}${customerComplaint}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetComplaintCategoryListService = async () => {
    try {
        return await AjexPortalService.get(`${complaintURL}${complaintCategory}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetComplaintPriorityListService = async () => {
    try {
        return await AjexPortalService.get(`${complaintURL}${complaintPriority}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SaveCustomerComplaintService = async (
    data: ICustomerComplaintList
) => {
    try {
        return await AjexPortalService.post(
            `${complaintURL}${customerComplaint}`,
            data
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetCustomerComplaintByIdService = async (
    id: number | undefined
) => {
    try {
        return await AjexPortalService.get(
            `${complaintURL}${customerComplaint}/${id}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetCommentByComplaintService = async (id: number | undefined) => {
    try {
        return await AjexPortalService.get(
            `${complaintURL}${customerComplaintComment}/${byComplaint}/${id}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetComplaintHistoryByComplaintService = async (
    id: number | undefined
) => {
    try {
        return await AjexPortalService.get(
            `${complaintURL}complaint-history/${byComplaint}/${id}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetComplaintSubCategoryByCategoryService = async (
    id: number | undefined
) => {
    try {
        return await AjexPortalService.get(
            `${complaintURL}complaint-sub-category/complaint-category/${id}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetCustomerInfoByWaybillService = async (waybill: string) => {
    try {
        return await AjexPortalService.get(
            `${complaintURL}${customerComplaint}/customer-info/${waybill}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetComplaintStatusListService = async () => {
    try {
        return await AjexPortalService.get(`${complaintURL}${complaintStatus}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetVehicleVisibilityListService = async () => {
    try {
        return await AjexPortalService.get(`${fleetURL}${vehicleVisibility}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetVehicleVisibilityByIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${fleetURL}${vehicleVisibility}/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetVehicleStatusHistoryByIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(
            `${fleetURL}${vehicle}/${vehicleStatusHistory}/${id}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const UpdateVehicleVisibilityByIdService = async (
    id: number | undefined,
    data: IVehicleVisibility
) => {
    try {
        return await AjexPortalService.put(
            `${fleetURL}${vehicleVisibility}/${id}`,
            data
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const UpdateCustomerComplaintService = async (
    id: number | undefined,
    data: ICustomerComplaintList
) => {
    try {
        return await AjexPortalService.put(
            `${complaintURL}${customerComplaint}/${id}`,
            data
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const AssignComplaintService = async (
    id: number | undefined,
    data: IComplaintAssignment
) => {
    try {
        return await AjexPortalService.put(
            `${complaintURL}${customerComplaint}/complaint-assign/${id}`,
            data
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const SaveCustomerComplaintCommentsService = async (
    data: IComplaintCommentsList
) => {
    try {
        return await AjexPortalService.post(
            `${complaintURL}${customerComplaintComment}`,
            data
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SearchComplaintFilterService = async (
    filteredData: ICustomerComplaintFilter
) => {
    try {
        return await AjexPortalService.post(
            `${complaintURL}${customerComplaint}/${filter}`,
            filteredData
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetComplaintUploadFileService = async (request: IFetchFiles) => {
    try {
        return await AjexPortalService.get(
            `${commonUrl}${fileAttachment}/download-by-category-id?category-id=${request?.categoryId}&${category}=${request?.category}&fileType=${request?.fileType}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetPodDispatchWaybillsPageService = async (
    pageNumber: number,
    pageSize: number,
    isAone?: boolean
) => {
    const url = isAone
        ? `${commonUrl}${podDispatch}/aone/pfn-waybills/paginated?page=${pageNumber}&size=${pageSize}`
        : `${reportURL}/pod-dispatch/paginated?page=${pageNumber}&size=${pageSize}`;
    try {
        return await AjexPortalService.get(url);
    } catch (error: unknown) {
        const err = error as AxiosError;
        return err?.response;
    }
};

export const SearchVehicleVisibilityFilterService = async (
    filteredData: IVehicleVisibilityFilter
) => {
    try {
        return await AjexPortalService.post(
            `${fleetURL}${fleet}/${assignment}/${filter}`,
            filteredData
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const AssignUnAssignService = async (request: IAssignUnAssignType) => {
    try {
        return await AjexPortalService.post(
            `${fleetURL}${fleet}/${assignment}`,
            request
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const AdhocAssignUnAssignService = async (request) => {
    try {
        return await AjexPortalService.post(
            `${fleetURL}${fleet}/${assignment}/${adhocFleetAssignment}`,
            request
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const CancelService = async (request: ICancelRequest) => {
    try {
        return await AjexPortalService.post(
            `${fleetURL}${fleet}/${assignment}/${cancel}`,
            request
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const NotifyDriverService = async (request: INotify) => {
    try {
        return await AjexPortalService.post(
            `${fleetURL}${fleet}/${assignment}/${notifyDriver}`,
            request
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

//http://localhost:6214/api/v1/fleet/assignment/driver/8
export const GetDriverAssignmentByIdService = async (id?: number) => {
    try {
        return await AjexPortalService.get(
            `${fleetURL}/${fleet}/assignment/driver/${id}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const GetVehicleAssignmentByIdService = async (id?: number) => {
    try {
        return await AjexPortalService.get(
            `${fleetURL}/${fleet}/assignment/vehicle-id/${id}`
        );
        // http://localhost:6214/api/v1/fleet/assignment/vehicle-id/430
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export interface IDriverAcknowledgeRequest {
    vehicleId: number;
    driverId: number;
    actionId: number;
}

export const DriverAcknowledgeService = async (request: IDriverAcknowledgeRequest) => {
    try {
        return await AjexPortalService.post(
            `${fleetURL}${fleet}/${assignment}/driver-acknowledge`,
            request
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const DownloadSingleFileService = async (id: number) => {
    // `https://apps-sit.aj-ex.com/tms-common-service/api/v1/file-attachment/download-single-file/${id}`
    try {
        return await AjexPortalService.get(
            `${commonUrl}/${fileAttachment}/download-single-file/${id}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

// http://localhost:6201/api/v1/calendar/month-pickup-count
export const GetPickupCountForMonthService = async (shipmentSummaryRequest: IShipmentSummaryRequest) => {
    try {
        return await AjexPortalService.post(`${commonUrl}/${calendar}/month-pickup-count`, shipmentSummaryRequest);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

// http://localhost:6201/api/v1/calendar/daily-pickup-count
export const GetShipmentStatusCountForDayService = async (shipmentSummaryRequest: IShipmentSummaryRequest) => {
    try {
        return await AjexPortalService.post(`${commonUrl}/${calendar}/daily-pickup-count`, shipmentSummaryRequest);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

// http://localhost:6201/api/v1/calendar/event-status-detail
export const GetShipmentStatusDetailForDayService = async (shipmentSummaryDetailsRequest: IShipmentSummaryDetailsRequest, paginationParams: PaginationParams) => {
    try {
        return await AjexPortalService.post(
            `${commonUrl}/${calendar}/event-status-detail?${page}=${paginationParams.current}&${size}=${paginationParams.pageSize}`,
            shipmentSummaryDetailsRequest);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const GetFuelPaymentModesService = async () => {
    try {
        return await AjexPortalService.get(`${fleetURL}/fuel-payment-type`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const GetFuelTrackingListService = async (paginationParams: PaginationParams, filterParams?: IFuelFilterParams) => {
    const { vehicleId, driverId, cityId, startDate, endDate } = filterParams || {};
    const { current, pageSize } = paginationParams || {};
    try {
        return await AjexPortalService.get(`${fleetURL}/${vehicleFuelTracking}/paginated?${page}=${current}&${size}=${pageSize}&vehicleId=${vehicleId ?? ""}&driverId=${driverId ?? ""}&cityId=${cityId ?? ""}&startDate=${startDate ?? ""}&endDate=${endDate ?? ""}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const AddFuelTrackingService = async (data: IFuelTrackingRequest) => {
    try {
        return await AjexPortalService.post(`${fleetURL}/${vehicleFuelTracking}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const EditFuelTrackingService = async (data: IFuelTrackingRequest, id: number) => {
    try {
        return await AjexPortalService.put(`${fleetURL}/${vehicleFuelTracking}/${id}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const GetFuelAuditHistoryService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${fleetURL}/${vehicleFuelTracking}/audit/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const GetFuelAuditPaginatedService = async (paginationParams: PaginationParams, filterParams: IFuelAuditPaginatedFilterParams) => {
    const { vehicleIds, startDate, endDate } = filterParams;
    const { current, pageSize } = paginationParams;
    try {
        const QueryClient = new URLSearchParams();
        if (vehicleIds) QueryClient.append('vehicleIds', vehicleIds.join(','));
        if (startDate) QueryClient.append('startDate', String(startDate));
        if (endDate) QueryClient.append('endDate', String(endDate));
        return await AjexPortalService.get(`${fleetURL}/${vehicleFuelTracking}/audit-paginated?${QueryClient.toString()}&${page}=${current}&${size}=${pageSize}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const GetFuelStationsService = async () => {
    try {
        return await AjexPortalService.get(`${fleetURL}/fuel-station`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const GetFuelRateListService = async (countryId: number) => {
    try {
        return await AjexPortalService.get(`${fleetURL}/vehicle-fuel-rate/country/${countryId}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const GetOdometerListService = async (paginationParams: PaginationParams, filterParams?: IOdometerFilterParams) => {
    const { vehicleId, driverId, cityId, startDate, endDate } = filterParams || {};
    const { current, pageSize } = paginationParams || {};
    try {
        return await AjexPortalService.get(`${fleetURL}/${odometerTracking}/paginated?${page}=${current}&${size}=${pageSize}&vehicleId=${vehicleId ?? ""}&driverId=${driverId ?? ""}&cityId=${cityId ?? ""}&startDate=${startDate ?? ""}&endDate=${endDate ?? ""}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const EditOdometerService = async (data: IOdometerRequest, id: number) => {
    try {
        return await AjexPortalService.put(`${fleetURL}/${odometerTracking}/vehicle/${id}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const UploadPickupDeliveryExceptionFileService = async (request) => {
    try {
        const configuration = {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        };
        return await AjexPortalService.post(`${commonUrl}${fileAttachment}/upload-multiple-file`, request, configuration)
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);
        return (err?.response)
    }
}

export const DownloadSOAFileService = async (req: DownloadSOAFileRequest) => {
    try {
        const { startDate, endDate, customerAccount } = req;
        return await AjexPortalService.get(`${CRMURL}reports/customer-statement?from=${startDate}&to=${endDate}&customerSubAccount=${customerAccount}`);
    } catch (error) {
        const err = error as AxiosError;
        return err?.response
    }
}
export const LegalNoticeFileUploadService = async (file) => {
    const formData = new FormData();
    formData.append('files', file?.file);
    const config = {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    };
    return await AjexPortalService.post(`${commonUrl}file-attachment/customer/upload-file`, formData, config);

}

export const GetCusLegalListService = async (payload) => {
    try {
        const queryParams = new URLSearchParams();
        if (payload?.startDate) queryParams.append('startDate', payload?.startDate);
        if (payload?.endDate) queryParams.append('endDate', payload?.endDate);
        if (payload?.isSendEmail) queryParams.append('isSendEmail', payload?.isSendEmail);
        if (payload?.pageNumber) queryParams.append('page', payload?.pageNumber);
        if (payload?.pageSize) queryParams.append('size', payload?.pageSize);

        return await AjexPortalService.get(`${commonUrl}file-attachment/customer/paginated?${queryParams.toString()}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const DownloadLegalAttachmentActionService = async (id: number) => {
    // https://apps-sit.aj-ex.com/tms-common-service/api/v1/file-attachment/customer-download-file/5
    try {
        return await AjexPortalService.get(
            `${commonUrl}${fileAttachment}/customer-download-file/${id}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SendLegalNoticeEmailService = async (payload) => {

    return await AjexPortalService.post(`${commonUrl}file-attachment/customer-send-email-bulk`, payload);

}

export const AddAdditionalMailService = async (payload) => {

    return await AjexPortalService.post(`${commonUrl}file-attachment/customer-add-email-bulk`, payload);

}

export const GetExceptionByPositionService = async (id) => {

    return await AjexPortalService.get(`${commonUrl}exception-approve/exception-validation-access?positionId=${id}&size=1000`);

}

export const GetMetabaseReportListService = async () => {
    try {
        return await AjexPortalService.get(`${commonUrl}metabase`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetMetabaseSignedTokenService = async (data: MetabaseRequestData) => {
    try {
        return await AjexPortalService.post(`${commonUrl}metabase`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const FetchCustomerComplaintListService = async (filter) => {
    try {
        // https://apps-sit.aj-ex.com/tms-complaint-mgmt-service/api/v1/customer-complaint/paginated?page=0&size=10&waybillNo=&subAccountId=&employeeId=&complaintStatus&stationId=&date=
        const queryParams = new URLSearchParams(
            Object.entries(filter)
                .filter(([key, value]) =>
                    value !== undefined &&
                    value !== null &&
                    value !== '' &&
                    value !== false
                )
                .map(([key, value]) => [key, String(value)])
        ).toString();
        return await AjexPortalService.get(`${complaintURL}customer-complaint/paginated?${queryParams}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetFTLNonAutoTripPlanWaybillsService = async (paginationParams: PaginationParams, filterParams?: IFTLTripPlanFilterParams) => {
    const { current, pageSize } = paginationParams || {};
    const requestData = filterParams ?? {};
    try {
        return await AjexPortalService.post(`${commonUrl}${tripPlan}/${wayBill}/${filter}?${page}=${current}&${size}=${pageSize}`, requestData);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const CreateFTLTripPlanService = async (waybillNos: React.Key | string[]) => {
    try {
        const payload = { waybillNos };
        return await AjexPortalService.post(
            `${commonUrl}${tripPlan}/waybill`,
            payload
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetIdleVehicleListService = async (paginationParams: PaginationParams, filterParams: IdleVehicleFilterParams) => {
    const { date, cityId, divisionId, categoryId, requestType } = filterParams || {};
    const { current, pageSize } = paginationParams || {};

    let url = `${fleetURL}idle-vehicle/paginated?${page}=${current}&${size}=${pageSize}&filterDate=${date}&cityId=${cityId ?? ""}&divisionId=${divisionId ?? ""}&categoryId=${categoryId ?? ""}`
    if (requestType) url = url + `&requestType=${requestType}`;

    try {
        return await AjexPortalService.get(url);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const GetIdleVehicleByIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${fleetURL}idle-vehicle/${id}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const CreateIdleVehicleExceptionService = async (data: IdleVehicleExceptionRequest) => {
    try {
        return await AjexPortalService.post(`${fleetURL}idle-vehicle`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const EditIdleVehicleExceptionService = async (id: number, data: IdleVehicleExceptionRequest) => {
    try {
        return await AjexPortalService.put(`${fleetURL}idle-vehicle/${id}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const CancelIdleVehicleExceptionService = async (id: number, data: IdleVehicleCancelExceptionRequest) => {
    try {
        return await AjexPortalService.put(`${fleetURL}idle-vehicle/is-cancel/${id}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};

export const ApproveRejectIdleVehicleExceptionService = async (id: number, data: IdleVehicleApproveRejectExceptionRequest) => {
    try {
        return await AjexPortalService.put(`${fleetURL}idle-vehicle/approve-reject/${id}`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
}; export const GetCityShipperListService = async (clientSubId: number) => {
    try {
        return await AjexPortalService.get(`${geofencingURL}geo-fencing/shipper?clientSubId=${clientSubId}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetCityConsigneeListService = async (clientSubId: number) => {
    try {
        return await AjexPortalService.get(`${geofencingURL}geo-fencing/consignee?clientSubId=${clientSubId}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetStationHubListService = async () => {
    try {
        return await AjexPortalService.get(`${geofencingURL}geo-fencing/station`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetGeofencingService = async (category: Category, categoryId: number) => {
    return await AjexPortalService.get(`${geofencingURL}geo-fencing?category=${category}&categoryId=${categoryId}`);
};

export const SaveGeofencingService = async (data: GeofenceSaveRequest) => {
    return await AjexPortalService.post(`${geofencingURL}geo-fencing`, data);
};

export const UpdateGeofencingService = async (data: GeofenceUpdateRequest) => {
    return await AjexPortalService.put(`${geofencingURL}geo-fencing`, data);
};

export const GetStationHubGeofenceListService = async () => {
    try {
        return await AjexPortalService.get(`${geofencingURL}geo-fencing/station/hubs`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetShipperGeofenceListService = async (subClientId: number, cityId: number) => {
    return await AjexPortalService.get(`${geofencingURL}geo-fencing/shipper-geofence?subClientId=${subClientId}&cityId=${cityId}`);
};

export const GetConsigneeGeofenceListService = async (subClientId: number, cityId: number) => {
    return await AjexPortalService.get(`${geofencingURL}geo-fencing/consignee-geofence?subClientId=${subClientId}&cityId=${cityId}`);
};

export const GetLatLngViaGeocodeService = async (cityName: string, cityId: number) => {
    return await AjexPortalService.put(`${geofencingURL}geo-fencing/location-update?cityId=${cityId}&cityName=${cityName}`);
};

export const GetCustomerConfigService = async (waybillNo: string) => {
    try {
        return await AjexPortalService.get(`${commonUrl}configuration/search?waybillNo=${waybillNo}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetNearbyGeoFencingService = async (lat: number, lng: number) => {
    try {
        return await AjexPortalService.get(`${geofencingURL}geo-fencing/nearby?lat=${lat}&lng=${lng}&radius=2000`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}
// http://localhost:6279/api/v1/geofence-history?vehiclePlateNumber=BUDGET%207967%20LSA%20SENSOR%20S&geoFenceId=41110&fromDate=2025-10-21T00%3A00%3A00Z&toDate=2025-10-21T12%3A14%3A59Z%27
export const GetStationHistoryService = async (param: {
    vehiclePlateNumber: string,
    geoFenceId: number,
    fromDate: string,
    toDate: string
}


) => {
    const { vehiclePlateNumber, geoFenceId, fromDate, toDate } = param;
    try {
        const queryParams = new URLSearchParams();

        if (vehiclePlateNumber) {
            queryParams.append("vehiclePlateNumber", vehiclePlateNumber);
        }

        if (geoFenceId !== undefined) {
            queryParams.append("geoFenceId", geoFenceId.toString());
        }
        if (fromDate) {
            queryParams.append("fromDate", fromDate);
        }
        if (toDate) {
            queryParams.append("toDate", toDate);
        }

        return await AjexPortalService.get(`${geofencingURL}geofence-history?${queryParams.toString()}`,);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};


export const GetStationHistoryByStationsService = async (params: {
    vehiclePlateNumber?: string;
    stationIds?: number[] | string;
    fromDate?: string;
    toDate?: string;
    divisionIds?: number[];
}) => {
    try {
        const { vehiclePlateNumber, stationIds, fromDate, toDate } = params || {};
        const queryParams = new URLSearchParams();

        if (vehiclePlateNumber) queryParams.append("vehiclePlateNumber", vehiclePlateNumber);
        if (stationIds) {
            const value = Array.isArray(stationIds) ? stationIds.join(",") : stationIds;
            queryParams.append("stationIds", value);
        }
        if (fromDate) queryParams.append("fromDate", fromDate);
        if (toDate) queryParams.append("toDate", toDate);
        if (params.divisionIds && params.divisionIds.length) {
            queryParams.append("divisionIds", `${params.divisionIds.join(",")}`);
        }



        return await AjexPortalService.get(
            `${geofencingURL}geofence-history/station?${queryParams.toString()}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetDriverListService = async (params?: {
    search?: string;  // optional search param if API supports filtering
}) => {
    try {
        const queryParams = new URLSearchParams();

        if (params?.search) queryParams.append("search", params.search);

        const url = `${occURL}occ/get-driver${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;

        return await AjexPortalService.get(url);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetVehicleRequestUploadFileService = async (request: IFetchFiles) => {
    try {
        return await AjexPortalService.get(
            `${commonUrl}${fileAttachment}/get-vehicle-request-files?vehicleId=${request?.categoryId}`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const UpdateShipperConsigneeCoordsService = async (data: IShipperConsigneeCoordsUpdate) => {
    try {
        return await AjexPortalService.put(`${geofencingURL}coordinate`, data);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetStationMissedVehicleDataService = async (date: string) => {
    try {
        return await AjexPortalService.post(`${fleetURL}/vehicle/get-station-missed-vehicle-data`, { date });
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};



export const GetShipperConsigneeStopsService = async (payload: {
    startDate: string;
    endDate: string;
    plateNumber: string;
    cityIdList: number[];
    businessTypesIdList: number[];
}) => {
    try {
        return await AjexPortalService.post(`${fleetURL}/vehicle/get-vehicles-route-stops`, payload);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetInvoiceStagingService = async (params: InvoiceStagingParams, filterParams?: InvoiceStagingFilterParams) => {
    const { customerSubAccounts, businessUnits, waybillNos, deliveryStartDate, deliveryEndDate } = filterParams || {};
    let queryParams = `?statuses=${encodeURIComponent(params?.statuses)}`;
    if (customerSubAccounts?.length) {
        queryParams += `&customerSubAccounts=${customerSubAccounts.join(',')}`;
    }
    if (businessUnits?.length) {
        queryParams += `&businessUnits=${businessUnits.join(',')}`;
    }
    if (deliveryStartDate !== undefined) {
        queryParams += `&deliveryStartDate=${deliveryStartDate}`;
    }
    if (deliveryEndDate !== undefined) {
        queryParams += `&deliveryEndDate=${deliveryEndDate}`;
    }
    if (filterParams?.errorStartDate !== undefined) {
        queryParams += `&errorStartDate=${filterParams.errorStartDate}`;
    }
    if (filterParams?.errorEndDate !== undefined) {
        queryParams += `&errorEndDate=${filterParams.errorEndDate}`;
    }
    if (filterParams?.automatedBilling !== undefined) {
        queryParams += `&automatedBilling=${filterParams.automatedBilling}`;
    }

    const payload = {
        waybillNos: waybillNos?.trim() ? toStringArray(waybillNos) : undefined,
    };

    try {
        return await AjexPortalService.post(`${invoiceStagingUrl}invoices-staging${queryParams}`, payload);
        // return await AjexPortalService.get(`${invoiceStagingUrl}invoices-staging${queryParams}`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetFFDCustomerByIdService = async () => {
    try {
        return await AjexPortalService.get(`${bookingURL}/customer/inter-division-accounts`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const PushToOracleStagingService = async (payload: string[]) => {
    try {
        return await AjexPortalService.post(`${invoiceStagingUrl}invoices-staging/push`, payload);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const RevalidateInvoiceStagingService = async (payload: string[]) => {
    try {
        return await AjexPortalService.put(`${invoiceStagingUrl}invoices-staging/revalidate`, payload);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}


export const GetCaseClosureTypesService = async (
) => {
    try {
        return await AjexPortalService.get(
            `${complaintURL}complaint-case-types`
        );
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const AllowEditInvoiceStagingService = async (payload: string[]) => {
    try {
        return await AjexPortalService.put(`${invoiceStagingUrl}invoices-staging/allow-edit`, payload);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
export const GetCnNoteReasonsService = async () => {
    try {
        return await AjexPortalService.get(`${commonUrl}cn-note-reasons/`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};




export const GetCROEmployeesService = async (req) => {
    try {
        return await AjexPortalService.post(`employee/find-employees-by-positions-id?isDriver=false`, req);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}



export const GetRouteTypesService = async () => {
    try {
        return await AjexPortalService.get(`route-type`);
    } catch (error: unknown) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);

        return err?.response;
    }
};